<div class="card w-100">
  <!-- ngx-datatables responsive -->
  <ngx-datatable *ngIf="rows"
    #table
    class="bootstrap core-bootstrap w-100"
    [columnMode]="ColumnMode"
    [headerHeight]="40"
    [rowHeight]="'auto'"
    [footerHeight]="'auto'"
    [rows]="rows"
    [scrollbarH]="true"
    [limit]="20"
    [count]="rows?.length"
    [selectionType]="SelectionType"
    (select)="onSelect($event)"
  >
    <ngx-datatable-column [headerClass]="'company'" [name]="type=='crypto'? 'Crypto' : 'Company'" [width]="100" prop="companyName" [sortable]="false">
      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
        <div #btnElement class="d-flex align-items-center w-100" (click)="emptyClickHandler(btnElement)" >
          <div>
            <ng-container *ngIf="this.type == 'stock'" >
              <img
                placement="right"
                [ngbTooltip]="row?.companyName"
                class="rounded-circle mr-1"
                [src]="'assets/images/ticker-icons/'+row?.ticker.toString().toUpperCase()+'.png'"
                class="mr-75"
                height="32"
                width="32"
              />
            </ng-container>
            <ng-container *ngIf="this.type == 'crypto'">
              <img
              placement="right"
              [ngbTooltip]="row?.companyName"
              class="rounded-circle mr-1"
              [src]="'assets/images/crypto-icons/'+row?.ticker.toString().toUpperCase()+'.jpg'"
              class="mr-75"
              height="32"
              width="32"
            />
            </ng-container>
          </div>
          <div class="cell-line-height w-100" placement="right" [ngbTooltip]="row?.companyName">
            <p class="font-medium-1 line-height-1 mb-0">{{ row?.ticker | uppercase }}</p>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="type=='stock'" [headerClass]="'price'" name="Price" prop="price" [width]="80" [sortable]="false">
      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
        <div #btnElement (click)="emptyClickHandler(btnElement)">
          {{row?.price | currency: 'USD':'symbol':'1.0-2'}}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="type=='crypto'" [headerClass]="'price'" name="Price" prop="price" [width]="80" [sortable]="false">
      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
        <div>
          ${{row?.price}}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [headerClass]="'percentagechange'" name="% Change" prop="percentageChange" [width]="80" [sortable]="false">
      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
        <div #btnElement (click)="emptyClickHandler(btnElement)">
          <span [ngClass]="{'text-success': row?.percentageChange > 0, 'text-danger': row?.percentageChange < 0}">{{row?.percentageChange | number : '1.0-2'}} <ng-container *ngIf="row?.percentageChange">%</ng-container></span>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [headerClass]="'sentiment'" name="Sentiment" prop="sentiment" [width]="100" [sortable]="false">
      <ng-template let-row="row" let-socialSentiment="value" ngx-datatable-cell-template>
        <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="socialSentiment" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.sentimentDesc"></ticker-value>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [headerClass]="'technical'" name="Technical" prop="technical" [width]="100" [sortable]="false">
      <ng-template let-row="row" let-socialSentiment="value" ngx-datatable-cell-template>
        <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="socialSentiment" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.technicalDesc"></ticker-value>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="this.type == 'stock'" [headerClass]="'fundamental'" name="Fundamental" prop="fundamental" [width]="110" [sortable]="false">
      <ng-template let-row="row" let-alternativeFundamental="value" ngx-datatable-cell-template>
        <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="alternativeFundamental" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.fundamentalDesc"></ticker-value>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="this.type == 'stock'" [headerClass]="'valuation'" name="Valuation" prop="valuation" [width]="100" [sortable]="false">
        <ng-template let-row="row" let-valuationLevel="value" ngx-datatable-cell-template>
          <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="valuationLevel" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.valuationDesc"></ticker-value>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="this.type == 'stock'" [headerClass]="'macro'" name="Macro" prop="macro" [width]="100" [sortable]="false">
        <ng-template let-row="row" let-macroCondition="value" ngx-datatable-cell-template>
          <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="macroCondition" [showLabel]="true" [tooltipDesc]="row?.scoreDescription?.macroDesc"></ticker-value>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="this.type == 'stock'" [cellClass]="'bg'" [headerClass]="'shortTermConviction'" name="Short term" prop="shortTermConviction" [width]="100" [sortable]="false">
      <ng-template let-shortTermConviction="value" ngx-datatable-cell-template>
        <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="shortTermConviction" [showLabel]="true"></ticker-value>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="this.type == 'stock'" [cellClass]="'bg'" [headerClass]="'longTermConviction'" name="Long term" prop="longTermConviction" [width]="100" [sortable]="false">
      <ng-template let-longTermConviction="value" ngx-datatable-cell-template>
        <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="longTermConviction" [showLabel]="true"></ticker-value>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column *ngIf="this.type == 'stock'" [cellClass]="'bg'" name="favorability" prop="score" [width]="120" [sortable]="false">
      <ng-template let-score="value" ngx-datatable-cell-template>
        <ticker-value #btnElement (click)="emptyClickHandler(btnElement)" [value]="score" [showLabel]="true" ></ticker-value>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [headerClass]="'action'" name="Action" *ngIf="action" [sortable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div #btnElement (click)="emptyClickHandler(btnElement)" class="d-flex align-items-center">
          <div ngbDropdown container="body">
            <a
              ngbDropdownToggle
              class="hide-arrow"
              id="dropdownBrowserState"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i data-feather="more-vertical" class="text-primary cursor-pointer mr-50"></i>
            </a>
            <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownBrowserState">
              <a (click)="ViewDetail(row)" ngbDropdownItem class="d-flex align-items-center"
                ><i data-feather="file-text" class="mr-50"></i> Details</a
              >
              <a (click)="deleteTicker(row, confirm)" ngbDropdownItem class="d-flex align-items-center"
                ><i data-feather="trash-2" class="mr-50"></i> Delete</a
              >
            </div>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer *ngIf="true">
      <ng-template
      ngx-datatable-footer-template
      let-rowCount="rowCount"
      let-pageSize="pageSize"
      let-selectedCount="selectedCount"
      let-curPage="curPage"
      let-offset="offset"
      let-isVisible="isVisible">

      <div class="page-count">
        <span>
            Showing {{(curPage * pageSize) - (pageSize - 1)}} to {{(curPage * pageSize) >= rowCount ? rowCount: (curPage * pageSize)}}
        </span>
        of {{rowCount.toLocaleString()}} entries
      </div>
    <datatable-pager
        [pagerLeftArrowIcon]="'datatable-icon-left'"
        [pagerRightArrowIcon]="'datatable-icon-right'"
        [pagerPreviousIcon]="'datatable-icon-prev'"
        [pagerNextIcon]="'datatable-icon-skip'"
        [page]="curPage"
        [size]="pageSize"
        [count]="rowCount"
        [hidden]="!((rowCount / pageSize) > 1)"
        (change)="table.onFooterPage($event)"
        >
    </datatable-pager>
    </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
  <!--/ ngx-datatables responsive -->
</div>

<!-- Chart Modal -->
<ng-template #confirm let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Confirm Dialog</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <p>Are you sure you want to delete</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="modal.close('Ok click')">Ok</button>
  </div>
</ng-template>
<!-- / Modal -->
